import React from 'react';
import { ScrollView, View } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';

import { AppHeader } from '../../../components/common';
import { GreenButton } from '../../../components/derivative';
import { AppText } from '../../../components/form';
import styles from './styles';

const LevelComplete = ({ navigation }) => (
  <View style={styles.viewBase}>
    <AppHeader title="PNFAM" />
    <View style={styles.content}>
      <ScrollView style={styles.scroll}>
        <View style={styles.viewIconHeart}>
          <Icon name="happy-outline" style={styles.iconHeart} />
        </View>
        <AppText style={styles.textPNFAM} size="bold">PARABÉNS</AppText>
        <AppText style={styles.textPNFAM}>{'Você completou a pesquisa\n de Nível Físico, Alimentar\n e Mental de forma \nbem-sucedida.'}</AppText>
        <AppText style={[styles.textPNFAM, styles.textMoreSpace]}>{'A CADA 15 DIAS\nUMA NOVA SOLICITAÇÃO'}</AppText>
        <GreenButton
          onPress={() => navigation.navigate('Worker Profile')}
          label={<AppText size="bold" style={styles.textButtonGreen}>VOLTAR</AppText>}
        />

      </ScrollView>
    </View>
  </View>
);

export default LevelComplete;
